
// ─────────────────────────────────────────────────────────────────────────────
// Xero Logo: Official Xero Blue (#13B5EA)
// The Xero mark is a rounded "xero" wordmark. We render a stylized "X" icon
// within a pill/roundel matching their brand treatment.
// ─────────────────────────────────────────────────────────────────────────────

export function XeroLogo({ size = 40 }: { size?: number }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Xero logo"
    >
      {/* Background circle */}
      <rect width="40" height="40" rx="10" fill="#13B5EA" />
      {/* "xero" wordmark: simplified to the X mark */}
      <g transform="translate(8, 9)">
        <text
          x="0"
          y="19"
          fontFamily="'SF Pro Display', 'Helvetica Neue', Helvetica, Arial, sans-serif"
          fontSize="17"
          fontWeight="800"
          letterSpacing="-0.5"
          fill="#FFFFFF"
        >
          xero
        </text>
      </g>
    </svg>
  );
}

// ─────────────────────────────────────────────────────────────────────────────
// Dashpivot / Sitemate Logo: Official Sitemate Blue (#2E81DA)
// Dashpivot is a product by Sitemate. We render a stylized "D" mark
// with a pivot indicator reflecting the "pivot" in the name.
// ─────────────────────────────────────────────────────────────────────────────

export function DashpivotLogo({ size = 40 }: { size?: number }) {
  const s = size / 40; // scale factor
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Dashpivot logo"
    >
      {/* Background */}
      <rect width="40" height="40" rx="10" fill="#2E81DA" />
      {/* Stylized "dp" monogram */}
      <g transform={`scale(${s})`}>
        {/* D shape: bold rounded letter */}
        <path
          d="M12 10h4c4.418 0 8 3.582 8 8s-3.582 8-8 8h-4V10z"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        {/* Pivot dot */}
        <circle cx="18" cy="20" r="2.5" fill="#FFFFFF" />
        {/* Measurement ticks (construction/field tools reference) */}
        <line x1="28" y1="12" x2="28" y2="28" stroke="#FFFFFF" strokeWidth="1.5" opacity="0.5" strokeLinecap="round" />
        <line x1="26" y1="14" x2="28" y2="14" stroke="#FFFFFF" strokeWidth="1.5" opacity="0.5" strokeLinecap="round" />
        <line x1="26" y1="20" x2="28" y2="20" stroke="#FFFFFF" strokeWidth="1.5" opacity="0.7" strokeLinecap="round" />
        <line x1="26" y1="26" x2="28" y2="26" stroke="#FFFFFF" strokeWidth="1.5" opacity="0.5" strokeLinecap="round" />
      </g>
    </svg>
  );
}
